import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { heroData } from '../mock';

export const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % heroData.heroImages.length
      );
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const scrollToAbout = () => {
    document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Images with Transition */}
      <div className="absolute inset-0">
        {heroData.heroImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-2000 ${
              index === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={image}
              alt={`Hero ${index + 1}`}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
          </div>
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center">
        {/* Logo */}
        <div className="mb-8 animate-fade-in">
          <h1 className="text-5xl md:text-7xl font-light tracking-[0.3em] text-white mb-2">
            SHRI
          </h1>
          <div className="h-px w-64 bg-gradient-to-r from-transparent via-white to-transparent mx-auto mb-2" />
          <p className="text-xl md:text-2xl font-light tracking-[0.4em] text-white/90">
            ENTERPRISE
          </p>
        </div>

        {/* Tagline */}
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-light text-white mb-6 max-w-5xl leading-tight animate-slide-up">
          {heroData.tagline}
        </h2>

        {/* Subtext */}
        <p className="text-base md:text-lg lg:text-xl text-white/80 max-w-3xl mb-12 font-light leading-relaxed animate-slide-up-delay">
          {heroData.subtext}
        </p>

        {/* CTA Button */}
        <button
          onClick={scrollToAbout}
          className="group flex flex-col items-center gap-3 transition-transform hover:translate-y-2 duration-500"
        >
          <span className="text-sm tracking-widest text-white/70 uppercase">Explore</span>
          <ChevronDown className="w-8 h-8 text-white animate-bounce" />
        </button>
      </div>

      {/* Image Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-2 z-20">
        {heroData.heroImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentImageIndex(index)}
            className={`h-1 transition-all duration-500 ${
              index === currentImageIndex ? 'w-12 bg-white' : 'w-6 bg-white/40'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};